<script>
import _ from 'lodash';
import { getLegalConfig } from './legal-config';
import { Tooltip } from 'element-ui';

const { find, get } = _;

export default {
    functional: true,
    props: {
        code: {
            required: true
        },
        isSimple: {
            type: Boolean,
            default: false
        },
        currentLang: {
            type: String
        },
        modeType: {
            type: String,
            default: 'default',
        },
    },
    render(h, { props, parent }) {
        const ElTooltip = Tooltip;
        const legalStatusData = getLegalConfig();
        const currentLegalStatus = find(legalStatusData, (item)=>{
            //Simple legal status和legal status里面的code有重复的部分(1和2)
            return item.code === props.code.toString() && (props.isSimple ? item.codeType === 'SIMPLE_LEGAL_STATUS' : true);
        });
        if (!currentLegalStatus) { return null; }
        const lightThemeTag = currentLegalStatus.codeType === 'LEGAL_EVENT';
        let styles = {
            borderColor: currentLegalStatus.color
        };
        const lang = props.currentLang || parent.$i18n.locale || 'en';
        lightThemeTag ? styles.color = currentLegalStatus.color : styles.backgroundColor = currentLegalStatus.color;
        const currentLabel = get(currentLegalStatus, `label.${lang}`, '');
        return (
            <ElTooltip visibleArrow={false} popperClass={'legal-tag__dot-tooltip'} openDelay={200} placement={'top'} disabled={props.modeType !== 'dot'}>
                <span class={`legal-tag legal-tag__${currentLegalStatus.codeType} legal-tag__mode-${props.modeType}`} style={styles}>
                    {currentLabel}
                </span>
                <div slot="content" style={{ backgroundColor: currentLegalStatus.color }} class="legal-tag__dot-tooltip__content">
                    {currentLabel}
                </div>
            </ElTooltip>
        );
    }
};
</script>

<style lang="scss">
.legal-tag {
    border-radius: 2px;
    padding: 2px 8px;
    text-align: center;
    font-size: 12px;
    color: #fff;
    border-style: solid;
    border-width: 1px;
    letter-spacing: 0.25px;
    display: inline-block;
    line-height: 18px;
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align:bottom;

    &__mode-dot {
        height: 8px;
        width: 8px;
        padding: 0;
        border-radius: 2px;
        font-size: 0;
    }
}

.legal-tag__dot-tooltip {
    padding: 0 !important;
    .legal-tag__dot-tooltip__content {
        padding: 2px 8px;
        font-size: 12px;
        line-height: 16px;
        border-radius: 4px;
    }
    &[x-placement^=top] {
        margin-bottom: 4px !important;
    }
    &[x-placement^=bottom] {
        margin-top: 4px !important;
    }
    &[x-placement^=left] {
        margin-right: 4px !important;
    }
    &[x-placement^=right] {
        margin-left: 4px !important;
    }
}
</style>
